export const ADD_SHOPS = 'ADD_SHOPS'
export const ADD_SHOP = 'ADD_SHOP'
export const SET_POS_CHECKOUT_STATUS = 'SET_POS_CHECKOUT_STATUS'
export const SET_POS_CHECKOUT_DETAILS = 'SET_POS_CHECKOUT_DETAILS'
export const SET_SHOP_DEFAULT_CURRENCY = 'SET_SHOP_DEFAULT_CURRENCY'
export const LOAD_SHOP_PRODUCT_SALE_ELEMENTS_BY_CATEGORIES = 'LOAD_SHOP_PRODUCT_SALE_ELEMENTS_BY_CATEGORIES'
export const LOAD_SHOP_PRODUCT_SALE_ELEMENTS = 'LOAD_SHOP_PRODUCT_SALE_ELEMENTS'
export const LOAD_SHOP_CATEGORIES = 'LOAD_SHOP_CATEGORIES'
